import React, { useState } from "react";
import { FiX, FiMessageSquare, FiPlus, FiTrash2 } from "react-icons/fi";

const CustomReplyModal = ({ show, handleClose, onSave }) => {
  const [formData, setFormData] = useState({
    triggerType: "",
    button: "",
    responses: [
      { id: 1, trigger: "", message: "" }
    ]
  });

  const triggerOptions = [
    { value: "button_click", label: "Button Click" },
    { value: "keyword", label: "Keyword Match" },
    { value: "regex", label: "Regex Pattern" }
  ];

  const buttonOptions = [
    { value: "help", label: "Help Button" },
    { value: "support", label: "Support Button" },
    { value: "contact", label: "Contact Button" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleResponseChange = (id, field, value) => {
    setFormData(prev => ({
      ...prev,
      responses: prev.responses.map(res => 
        res.id === id ? { ...res, [field]: value } : res
      )
    }));
  };

  const addResponse = () => {
    setFormData(prev => ({
      ...prev,
      responses: [...prev.responses, { 
        id: prev.responses.length + 1, 
        trigger: "", 
        message: "" 
      }]
    }));
  };

  const removeResponse = (id) => {
    if (formData.responses.length > 1) {
      setFormData(prev => ({
        ...prev,
        responses: prev.responses.filter(res => res.id !== id)
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content border-0 shadow" style={{overflowY:'auto'}}>
          <div className="modal-header bg-info text-white">
            <h5 className="modal-title">
              <FiMessageSquare className="me-2" />
              Custom Reply Configuration
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={handleClose}>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="alert alert-info">
                <small>
                  Configure custom automated replies based on customer responses.
                </small>
              </div>

              <div className="mb-4">
                <label className="form-label fw-bold d-block mb-2">Trigger Type</label>
                <select 
                  name="triggerType"
                  value={formData.triggerType}
                  onChange={handleChange}
                  className="form-select form-select-lg"
                  required
                >
                  <option value="">Select trigger type</option>
                  {triggerOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              {formData.triggerType === "button_click" && (
                <div className="mb-4">
                  <label className="form-label fw-bold d-block mb-2">Select Button</label>
                  <select 
                    name="button"
                    value={formData.button}
                    onChange={handleChange}
                    className="form-select form-select-lg"
                    required
                  >
                    <option value="">Select button</option>
                    {buttonOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )}

              <div className="mb-3">
                <label className="form-label fw-bold d-block mb-2">Response Rules</label>
                {formData.responses.map((response) => (
                  <div key={response.id} className="card mb-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Response {response.id}</h6>
                        {formData.responses.length > 1 && (
                          <button 
                            type="button" 
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeResponse(response.id)}
                          >
                            <FiTrash2 />
                          </button>
                        )}
                      </div>
                      
                      {formData.triggerType === "keyword" && (
                        <div className="mb-3">
                          <label className="form-label">Trigger Keywords (comma separated)</label>
                          <input
                            type="text"
                            value={response.trigger}
                            onChange={(e) => handleResponseChange(response.id, 'trigger', e.target.value)}
                            className="form-control"
                            placeholder="help, support, contact"
                            required
                          />
                        </div>
                      )}

                      {formData.triggerType === "regex" && (
                        <div className="mb-3">
                          <label className="form-label">Regex Pattern</label>
                          <input
                            type="text"
                            value={response.trigger}
                            onChange={(e) => handleResponseChange(response.id, 'trigger', e.target.value)}
                            className="form-control"
                            placeholder="^(help|support|contact)$"
                            required
                          />
                          <small className="text-muted">Use standard regex syntax</small>
                        </div>
                      )}

                      <div className="mb-2">
                        <label className="form-label">Response Message</label>
                        <textarea
                          value={response.message}
                          onChange={(e) => handleResponseChange(response.id, 'message', e.target.value)}
                          className="form-control"
                          rows="3"
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>
                ))}

                <button 
                  type="button" 
                  className="btn btn-outline-primary btn-sm"
                  onClick={addResponse}
                  disabled={formData.responses.length >= 5}
                >
                  <FiPlus className="me-1" />
                  Add Response {formData.responses.length < 5 ? `(${formData.responses.length}/5)` : '(Max reached)'}
                </button>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-info">
                Save Configuration
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomReplyModal;